/* import __COLOCATED_TEMPLATE__ from './location-selector-field.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { subunitsLabel } from '@dashboard/junk-drawer/utils/subunits';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { itemSubunitsServiceActiveSubunits } from '@square/dashboard-utilities/utils/item-subunits';
const LOCATION_OPTION_GLOBALLY_ENABLED_VALUE = 'globally_enabled';
let LocationSelectorField = (_class = class LocationSelectorField extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "locationSelector", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "isSelectingLocations", _descriptor3, this);
    // This value is passed in to a market-select component which is readonly
    // and is only used to display the selected value of the location.
    _defineProperty(this, "dummyValueForDisplay", 'selected-value-for-display');
  }
  get locationsLabel() {
    const selectedLocationsNicknames = this.args.selectedLocations.map(({
      nickname
    }) => nickname);
    return subunitsLabel(selectedLocationsNicknames, this.activeLocations.length);
  }
  get activeLocations() {
    return itemSubunitsServiceActiveSubunits();
  }
  get locationOptions() {
    if (!this.isSelectingLocations) {
      return [];
    }
    const selectedLocationTokens = new Set(this.args.selectedLocations.map(({
      token
    }) => token));
    const disabledLocationTokens = new Set((this.args.disabledLocations ?? []).map(({
      token
    }) => token));
    const options = this.activeLocations.map(location => {
      const disabled = disabledLocationTokens.has(location.token);
      return {
        value: location.token,
        label: location.nickname,
        checked: selectedLocationTokens.has(location.token) && !disabled,
        disabled
      };
    });
    const globallyEnabledOption = {
      value: LOCATION_OPTION_GLOBALLY_ENABLED_VALUE,
      label: this.intl.t('sharedUi.locationsSelectorModal.globallyEnabledLabel'),
      checked: this.args.globallyEnabled,
      disabled: false
    };
    options.push(globallyEnabledOption);
    return options;
  }
  get modalOptions() {
    return {
      title: this.intl.t('sharedUi.locationsSelectorModal.title'),
      primaryButtonLabel: this.intl.t('sharedUi.locationsSelectorModal.primaryButtonLabel'),
      selectAllLabel: this.intl.t('sharedUi.locationsSelectorModal.selectAllLabel'),
      searchPlaceholder: this.intl.t('sharedUi.locations'),
      enableSearch: true,
      enableSelectAll: true,
      options: this.locationOptions,
      ...this.args.modalOptions
    };
  }
  openModal() {
    this.isSelectingLocations = true;
  }
  closeModal(event) {
    this.isSelectingLocations = false;
    if (!Array.isArray(event)) {
      return;
    }
    const locationChangeEvent = event.reduce((changeEvent, currentValue) => {
      const value = `${currentValue.value}`;
      if (value === LOCATION_OPTION_GLOBALLY_ENABLED_VALUE) {
        return {
          ...changeEvent,
          globallyEnabled: currentValue.checked
        };
      } else if (currentValue.checked) {
        changeEvent.selectedLocationTokens.add(value);
      } else {
        changeEvent.deselectedLocationTokens.add(value);
      }
      return changeEvent;
    }, {
      selectedLocationTokens: new Set(),
      deselectedLocationTokens: new Set()
    });
    if (locationChangeEvent.globallyEnabled) {
      locationChangeEvent.selectedLocationTokens.clear();
    }
    this.args.onChange(locationChangeEvent);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isSelectingLocations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "openModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _class);
export { LocationSelectorField as default };